import { render, staticRenderFns } from "./WsIconBtn.vue?vue&type=template&id=096db11a&"
import script from "./WsIconBtn.vue?vue&type=script&lang=js&"
export * from "./WsIconBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports